import React,{useState,useEffect, useMemo} from "react";
import html2pdf from 'html2pdf.js';

const InvoiceDetailView = (({
  headerSlides,
  footerSlides,
  currentHeaderSlide,
  currentFooterSlide,
  headerSecondaryImage,
  footerSecondaryImage,
  headerTimeRemaining,
  footerTimeRemaining,
  nextHeaderSlide,
  prevHeaderSlide,
  nextFooterSlide,
  prevFooterSlide,
  invoiceData,
  logoImage,
  popupMedia
}) => {
    // console.log("header", headerSlides);
    // console.log("footer", footerSlides);
    // console.log("invoiceData", invoiceData);
    // console.log("popupMedia", popupMedia);
    // console.log("logoimage",logoImage);
    // console.log("headerSecondaryImage", headerSecondaryImage);
    // console.log("footerSecondaryImage", footerSecondaryImage);

    const [isLoading, setIsLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [htmlContent, setHtmlContent] = useState("");

    const storeName = invoiceData?.storeInfo?.name || "Store Name";
    const regionName = invoiceData?.storeInfo?.region?.name || "Region Name";

    useEffect(() => {
        if (popupMedia && popupMedia.url) {
          setShowPopup(true);
        }
      }, [popupMedia]);


      
      const handlePopupClose = () => {
        setShowPopup(false);
      };

    const pdfUrl = invoiceData?.pdf_link || "";

    const handlePdfDownload =  async (filename = 'Yourbill.pdf') => {
      // Create a temporary link element

      // console.log('Filename:', filename);

      try {
        const response = await fetch(pdfUrl, {
          mode: 'cors', 
        });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('Download failed:', error);
      }
    };
    
    // console.log("pdfUrl", pdfUrl);  

    const invoiceUrl = invoiceData?.billLink || "";
    useEffect(() => {
      const fetchHtml = async () => {
        const res = await fetch(invoiceUrl);
        const rawHtml = await res.text();

        // Step 2: Inject custom CSS to override styles
        const enhancedHtml = injectResponsiveStyle(rawHtml);

        setHtmlContent(enhancedHtml);
      };

      fetchHtml();
    }, []);

    const injectResponsiveStyle = (html) => {
      const styleTag = `
        <style>
          * {
            box-sizing: border-box;
          }
          table {
            width: 100% !important;
            max-width: 100% !important;
          }
          td, th {
            word-break: break-word;
          }
          body {
            margin: 5px;
            padding: 5px;
          }
        </style>
      `;
    
      // Insert style tag just after <head> or before <body>
      if (html.includes("<head>")) {
        return html.replace("<head>", `<head>${styleTag}`);
      } else {
        return `${styleTag}${html}`;
      }
    };

    const getMediaType = (url) => {
        if (!url) return 'unknown';
        
        const lowerCaseUrl = url.toLowerCase();
        // console.log("url",url);
        if (
          lowerCaseUrl.includes('youtube.com/watch') ||
          lowerCaseUrl.includes('youtu.be/') ||
          lowerCaseUrl.includes('youtube.com/embed/')
        ){
          return 'link';
        }
        if (lowerCaseUrl.endsWith('.mp4') || lowerCaseUrl.endsWith('.webm')) return 'video';
        if (lowerCaseUrl.endsWith('.gif')) return 'gif';
        return 'image'; // Default to image for other formats
      };
      
      const popupMediaType = popupMedia ? getMediaType(popupMedia.url) : 'unknown';
      // console.log("popupmedia type",popupMediaType);

      const handleOrderNow = () => {
        if (popupMedia && popupMedia.text) {
          window.open(popupMedia.text, '_blank');
        }
      };
      const handleImageClick = (redirectLink) => {
        // console.log("redirectlink",redirectLink)
        if (redirectLink) {
          window.open(redirectLink, '_blank', 'noopener,noreferrer');
        }
      }

      const hasHeaderSlides = Array.isArray(headerSlides) && headerSlides.length > 0;
      const hasFooterSlides = Array.isArray(footerSlides) && footerSlides.length > 0;
      // console.log("slides slides",headerSlides);
      // console.log("slide 1",headerSlides[currentHeaderSlide]);

  return (
    <div className="max-w-lg mx-auto p-2">
    {/* Popup Modal */}
    {showPopup && popupMedia && (
  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden relative pt-4">
      
      {/* Floating Close Button */}
      <button
        onClick={handlePopupClose}
        className="absolute top-1 right-4 bg-red-600 text-white w-6 h-6 rounded-full flex items-center justify-center shadow-md hover:bg-red-700"
        aria-label="Close popup"
      >
        ✕
      </button>

      <div className="p-4">
        {popupMediaType === 'video' && (
          <video
            src={popupMedia.url}
            controls
            autoPlay
            className="w-full rounded"
          />
        )}

        {(popupMediaType === 'gif' || popupMediaType === 'image') && (
          <img
            src={popupMedia.url}
            alt="Special offer"
            className="w-full rounded"
          />
        )}
        {popupMediaType === 'link' && (
          <div className="w-full aspect-video">
            <iframe
              src={`${popupMedia.url}${popupMedia.url.includes('?') ? '&' : '?'}autoplay=1&mute=1`}
              title="YouTube video preview"
              className="w-full h-full rounded"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>
    </div>
  </div>
)}


    

      {/* Header Carousel */}
      {hasHeaderSlides && (
        <div className="relative mb-2 rounded-lg overflow-hidden">
          <img
            src={headerSlides[currentHeaderSlide]?.url}
            alt={headerSlides[currentHeaderSlide]?.title}
            className={`w-full h-32 sm:h-40 object-fill ${
              headerSlides[currentHeaderSlide]?.redirect_link ? 'cursor-pointer' : ''
            }`}
            onClick={() => {
              if (headerSlides[currentHeaderSlide]?.redirect_link) {
                handleImageClick(headerSlides[currentHeaderSlide].redirect_link);
              }
            }}
          />
                      
          {headerSlides && headerSlides.length > 1 && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
              <div
                className="h-full bg-blue-500"
                style={{ width: `${headerTimeRemaining}%` }}>
              </div>
            </div>
          )}
                      
          {/* Navigation buttons positioned at edges without covering the center */}
          <button
            onClick={prevHeaderSlide}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-1 sm:p-2 rounded-full hover:bg-opacity-50 text-sm z-10"
          >
            ←
          </button>
          <button
            onClick={nextHeaderSlide}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-1 sm:p-2 rounded-full hover:bg-opacity-50 text-sm z-10"
          >
            →
          </button>
        </div>
      )}
           {/* Secondary Header Image */}

          {headerSecondaryImage && ((headerSecondaryImage && headerSecondaryImage.redirect_link )? (
              <img
                src={headerSecondaryImage.url}
                alt="Secondary Promotion"
                className="w-full h-24 sm:h-32 object-fill cursor-pointer"
                onClick={() => handleImageClick(headerSecondaryImage.redirect_link)}
              />
            ) : (
              <img
                src={headerSecondaryImage.url}
                alt="Secondary Promotion"
                className="w-full h-24 sm:h-32 object-fill"
              />
            ))}
      {/* Brand Card */}
      <div className="bg-white rounded-lg shadow-md p-4 mb-2">
      <div className="flex items-center">
      {logoImage && (
            <>
              {logoImage.redirect_link ? (
                <img
                  src={logoImage.url}
                  alt="Brand Logo"
                  className="w-18 h-12 sm:w-18 sm:h-16 mr-3 cursor-pointer"
                  onClick={() => handleImageClick(logoImage.redirect_link)}
                />
              ) : (
                <img
                  src={logoImage.url}
                  alt="Brand Logo"
                  className="w-18 h-12 sm:w-18 sm:h-16 mr-3"
                />
              )}
            </>
          )}  
          <div>
            <h2 className="font-bold text-lg sm:text-xl">{storeName}</h2>
            <div className="mt-3 text-sm text-gray-700">
            <p><span className="font-medium">Region:</span> {regionName}</p>
          </div>
        </div>
      </div>
    </div>

      {/* Invoice Image */}
      <div className="bg-white rounded-lg shadow-md p-4 mb-2">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-md sm:text-lg">E-Invoice</h3>
          <div>
            <button 
                onClick={() => handlePdfDownload('Yourbill.pdf')}
                className="bg-green-600 text-white py-1 px-3 sm:py-2 sm:px-4 rounded text-sm hover:bg-green-700"
                > Download
            </button>
          </div>
        </div>

        <div className="border rounded-lg overflow-hidden">
          <div
            className="w-full"
            style={{ overflowX: 'auto' }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
          
        </div>
      </div>

      {/* Footer Carousel */}
      {hasFooterSlides && footerSlides[0] && (
        <div className="relative mb-4 rounded-lg overflow-hidden">
          <img
            src={footerSlides[currentFooterSlide]?.url}
            alt={footerSlides[currentFooterSlide]?.title}
            className={`w-full aspect-square object-fill ${
              footerSlides[currentFooterSlide]?.redirect_link ? 'cursor-pointer' : ''
            }`}
            onClick={() => {
              if (footerSlides[currentFooterSlide]?.redirect_link) {
                handleImageClick(footerSlides[currentFooterSlide].redirect_link);
              }
            }}
          />

          {footerSlides && footerSlides.length > 1 && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
              <div
                className="h-full bg-blue-500"
                style={{ width: `${footerTimeRemaining}%` }}>
              </div>
            </div>
          )}
        
          {/* Navigation buttons positioned at edges without covering the center */}
          <button
            onClick={prevFooterSlide}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-1 sm:p-2 rounded-full hover:bg-opacity-50 text-sm z-10"
          >
            ←
          </button>
          <button
            onClick={nextFooterSlide}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-30 text-white p-1 sm:p-2 rounded-full hover:bg-opacity-50 text-sm z-10"
          >
            →
          </button>
        </div>
      )}

     

     {footerSecondaryImage && (
        <div className="mb-4">
          <div className="rounded-lg overflow-hidden shadow-md">
            {footerSecondaryImage.redirect_link ? (
              <img
                src={footerSecondaryImage.url}
                alt="Footer Promotion"
                className="w-full aspect-square object-fill cursor-pointer"
                onClick={() => handleImageClick(footerSecondaryImage.redirect_link)}
              />
            ) : (
              <img
                src={footerSecondaryImage.url}
                alt="Footer Promotion"
                className="w-full aspect-square object-fill"
              />
            )}
          </div>
        </div>
      )}


      {/* Powered by Footer */}
      <div className="text-center py-3 border-t bg-gray-200">
        <p className="text-gray-600 text-xs">Digital Billing Powered by</p>
        <div className="flex justify-center mt-1">
          <img
           src="https://www.restroworks.com/wp-content/uploads/2023/09/restroworks-logo.png" 
            alt="RetroWorks Logo"
            className="h-6"
          />
        </div>
      </div>
    </div>
  );
});

export default InvoiceDetailView;
